var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLupa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4661 20.654L14.2041 14.392C13.7041 14.818 13.1291 15.1477 12.4791 15.381C11.8291 15.6144 11.1757 15.731 10.5191 15.731C8.91773 15.731 7.5624 15.1767 6.45306 14.068C5.34373 12.9594 4.78906 11.6044 4.78906 10.003C4.78906 8.40171 5.34306 7.04605 6.45106 5.93605C7.55906 4.82605 8.91373 4.27038 10.5151 4.26905C12.1164 4.26771 13.4724 4.82238 14.5831 5.93305C15.6937 7.04371 16.2491 8.39938 16.2491 10C16.2491 10.6947 16.1261 11.367 15.8801 12.017C15.6341 12.667 15.3107 13.223 14.9101 13.685L21.1721 19.946L20.4661 20.654ZM10.5201 14.73C11.8467 14.73 12.9667 14.2734 13.8801 13.36C14.7934 12.4467 15.2501 11.3264 15.2501 9.99904C15.2501 8.67171 14.7934 7.55171 13.8801 6.63905C12.9667 5.72638 11.8467 5.26971 10.5201 5.26905C9.1934 5.26838 8.07306 5.72505 7.15906 6.63905C6.24506 7.55305 5.7884 8.67305 5.78906 9.99904C5.78973 11.325 6.2464 12.445 7.15906 13.359C8.07173 14.273 9.19173 14.7297 10.5191 14.729",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLupa);
export default __webpack_public_path__ + "static/media/lupa.efe4d5cb0c9e22d9a5ef54b5715a4f7e.svg";
export { ForwardRef as ReactComponent };